import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { Warning as WarningIcon } from '@material-ui/icons';

import { FetchError } from '../../common/api/api';
import AppSnackbar from '../../common/AppSnackbar';
import HeaderBackButton from '../../common/HeaderBackButton';
import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateDashboard from '../../common/page-template/PageTemplateDashboard';
import PageTemplateHeader from '../../common/page-template/PageTemplateHeader';
import ErrorView from '../../common/views/ErrorView';
import { useFindSignupById } from '../../login/Signup.hooks';
import { Signup } from '../../login/Signup.interface';
import SignupCompanyInfoCard from './cards/SignupCompanyInfoCard';
import SignupFeaturesCard from './cards/SignupFeaturesCard';
import SignupInviteUsersCard from './cards/SignupInviteUsersCard';
import SignupUserCard from './cards/SignupUserCard';

const StyledPageTemplate = styled(PageTemplate)`
  .page-template-header {
    margin-left: -16px;
  }
`;

export const RiskDetailPage: React.FC = () => {
  const { id: paramId = '' } = useParams<{ id?: string }>();
  const signupId = parseInt(paramId) || 0;
  const [signup, setSignup] = useState<Signup>();
  const [error, setError] = useState<FetchError>();
  const {
    signup: foundSignup,
    isLoading,
    error: findError,
    get
  } = useFindSignupById(signupId);

  useEffect(() => {
    get();
  }, [get]);

  useEffect(() => {
    foundSignup && setSignup(foundSignup);
  }, [foundSignup]);

  useEffect(() => {
    setError(findError);
  }, [findError]);

  return (
    <StyledPageTemplate>
      <PageTemplateHeader>
        <HeaderBackButton to='/portal/admin/signups' />
        <h2>{signup && `SIGNUP-${signup.id}`}</h2>
      </PageTemplateHeader>
      <PageTemplateDashboard>
        {!signup && !isLoading && findError && (
          <ErrorView
            title='Sign Up Error'
            description={findError.message}
            icon={<WarningIcon color='disabled' fontSize='inherit' />}
          />
        )}
        {signup && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <SignupCompanyInfoCard signup={signup} />
                </Grid>
                <Grid item xs={12}>
                  <SignupFeaturesCard signup={signup} />
                </Grid>
                <Grid item xs={12}>
                  <SignupInviteUsersCard signup={signup} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <SignupUserCard signup={signup} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </PageTemplateDashboard>

      <AppSnackbar
        severity='error'
        open={!!error}
        onClose={() => setError(undefined)}
      >
        {error?.message}
      </AppSnackbar>
    </StyledPageTemplate>
  );
};

export default RiskDetailPage;
